import { render, staticRenderFns } from "./categories-dropdown.vue?vue&type=template&id=11414f70&"
import script from "./categories-dropdown.vue?vue&type=script&lang=js&"
export * from "./categories-dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports